export default __webpack_public_path__ + "static/PC_3_1-a63925b3861b2e096a84cb034d9345c3.png";